module.exports = __webpack_public_path__ + "img/small.70b85f56.jpg";